module.exports = __webpack_public_path__ + "static/media/carousel_quienes_somos_1.e78d56e6.jpg";